var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4726)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 10.4C11.1314 10.4 11.4 10.6686 11.4 11V14.6C11.4 14.9314 11.1314 15.2 10.8 15.2C10.4686 15.2 10.2 14.9314 10.2 14.6V11C10.2 10.6686 10.4686 10.4 10.8 10.4Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 14.6V11C13.8 10.6686 13.5314 10.4 13.2 10.4C12.8686 10.4 12.6 10.6686 12.6 11V14.6C12.6 14.9314 12.8686 15.2 13.2 15.2C13.5314 15.2 13.8 14.9314 13.8 14.6Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7.4V6.8C9 6.32261 9.18964 5.86477 9.52721 5.52721C9.86477 5.18964 10.3226 5 10.8 5H13.2C13.6774 5 14.1352 5.18964 14.4728 5.52721C14.8104 5.86477 15 6.32261 15 6.8V7.4H17.4C17.7314 7.4 18 7.66863 18 8C18 8.33137 17.7314 8.6 17.4 8.6H16.8V16.4C16.8 16.8774 16.6104 17.3352 16.2728 17.6728C15.9352 18.0104 15.4774 18.2 15 18.2H9C8.52261 18.2 8.06477 18.0104 7.72721 17.6728C7.38964 17.3352 7.2 16.8774 7.2 16.4V8.6H6.6C6.26863 8.6 6 8.33137 6 8C6 7.66863 6.26863 7.4 6.6 7.4H9ZM10.3757 6.37574C10.4883 6.26321 10.6409 6.2 10.8 6.2H13.2C13.3591 6.2 13.5117 6.26321 13.6243 6.37574C13.7368 6.48826 13.8 6.64087 13.8 6.8V7.4H10.2V6.8C10.2 6.64087 10.2632 6.48826 10.3757 6.37574ZM8.4 8.6V16.4C8.4 16.5591 8.46321 16.7117 8.57574 16.8243C8.68826 16.9368 8.84087 17 9 17H15C15.1591 17 15.3117 16.9368 15.4243 16.8243C15.5368 16.7117 15.6 16.5591 15.6 16.4V8.6H8.4Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.5a1e605444135d29a24fac22635b8acf.svg";
export { ForwardRef as ReactComponent };